import { render, staticRenderFns } from "./PopUpModals.vue?vue&type=template&id=48df5a30&"
import script from "./PopUpModals.vue?vue&type=script&lang=js&"
export * from "./PopUpModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports